import {Enterprise} from "@/types/core";
import {HttpResponse} from "@/types/http";
import {CoreClient, curCoreClient} from "@/services/CoreClient";
import * as _ from "lodash";
import {DeviceService} from "@/services/DeviceService";

export class EnterpriseService {
  // internal dependencies
  private coreClient:CoreClient = curCoreClient;

  public async getEnterprises(query: GetEnterpriseQuery): Promise<HttpResponse & GetEnterprisesReply> {
    const reply = await this.coreClient.getEnterprisesAndGroups(query);

    if (reply.errorMsg) {
      return Promise.resolve({errorMsg: reply.errorMsg, httpCode: reply.httpCode});
    }

    const enterprises:Enterprise[] = _.map(_.keys(reply.enterprises), enterprise => {
      return {
        enterpriseId: enterprise,
        groupList: reply.enterprises[enterprise],
        treeList: [],
        numDevices: {
          direct: 0,
          all: 0,
        },
      };
    });

    return Promise.resolve({
      totalNumberOfPages: reply.totalNumberOfPages,
      enterprisePage: {
        enterpriseList: enterprises,
      }
    });
  }
}

export interface GetEnterpriseQuery {
  pageNumber: number;
  pageSize: number;
  filter?: string;
}

export interface GetEnterprisesReply {
  totalNumberOfPages?: number;
  enterprisePage?:EnterprisePage;
}

export interface EnterprisePage {
  enterpriseList: Enterprise[];
}

export const curEnterpriseService = new EnterpriseService();